import React from "react";
import { CommandBarButton, depascalize } from "sprint-common-web";

import { CloudFileStatus } from "../../../common/types/CloudFileStatus";
import { CloudFileDetails } from "../../CloudFileDetails";

export interface CloudFileInfoStatusButtonProps {
    cloudFileDetails?: CloudFileDetails;
}

export const CloudFileInfoStatusButton = ({ cloudFileDetails }: CloudFileInfoStatusButtonProps): JSX.Element => {
    if (!cloudFileDetails) {
        return <></>;
    }

    return (
        <CommandBarButton
            text={`Status: ${depascalize(CloudFileStatus[cloudFileDetails.status]) || "..."}`}
            disabled={true}
            testId="cloud-file-status-button"
        />
    );
};
